import numeral from 'numeral';

export const keys = (t) => [
    {
        key: 'clicksL',
        label: t('search.countries.module1.clicks'),
        icon: 'pagev-view',
        yAxisID: 'y3',
    },
    {
        key: 'impressionsL',
        label: t('search.countries.module1.impressions'),
        icon: 'pagev-view',
    },
    {
        key: 'ctrL',
        label: t('search.countries.module1.avgCTR'),
        yAxisID: 'y1',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'search',
    },
    {
        key: 'positionL',
        label: t('search.countries.module1.position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
    },
];

export default keys;
